import { StylesConfig } from "react-select";

export const selectStyles: StylesConfig = {
  control: (styles) => ({ ...styles, height: "100%" }),
  placeholder: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#536493",
  }),
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? "#536493" : "#536493",
    };
  },
  indicatorsContainer: (styles) => ({
    ...styles,
    color: "#536493",
  }),
};
